import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { selectPrefix, selectWidth } from "../../utility/Redux/profile";
import { selectToken } from "../../utility/Redux/security";
import { setSpinnerLoading } from "../../utility/Redux/modal";
import CallAPI from "../../utility/functions/getData";
import { PartyColumns } from "./columns";
import { Pagination } from "@mui/material";
import GeniusTableReports from "../../utility/component/geniusComponents/geniusTableData";
const PartyList = ({
  stationId,
  fullList,
  setFullList,
  parties,
  setParties,
}) => {
  const prefix = useSelector(selectPrefix);
  const windowWidth = useSelector(selectWidth);
  const [searchText, setSearchText] = useState("");
  const [currentPage, setCurrentpage] = useState(1);
  const [totalPageNumber, setToytalpageNumber] = useState(1);
  const columns = PartyColumns(windowWidth);

  const token = useSelector(selectToken);
  const dispatch = useDispatch();
  const getAccountData = (page) => {
    dispatch(setSpinnerLoading("Loading"));
    CallAPI(
      `/api/accountMaster/listAccountMaster`,
      {
        // table_prefix: prefix,
        table_prefix: prefix,
        mobile: "",
        name: "",
        page: page ? page : currentPage,
      },
      token,
      (e) => {
        if (!e.data.error) {
          setToytalpageNumber(e.data.response.pagination.totalPages);
          setCurrentpage(e.data.response.pagination.page);
          setParties(e.data.response.data);
          setFullList(e.data.response.data);
        }
      },
      dispatch,
      () => {
        dispatch(setSpinnerLoading(false));
      }
    );
  };

  useEffect(() => {
    if (!fullList[0]) {
      getAccountData();
    }
  }, [stationId]);

  useEffect(() => {
    if (searchText) {
      const regex = /\d+/;

      const searchItems = fullList.filter((item) => {
        if (regex.test(searchText.substring(0, 1))) {
          return item.MOBILE.toString().includes(searchText);
        } else {
          return item.NAME.toLowerCase().includes(searchText.toLowerCase());
        }
      });

      setParties(searchItems);
    } else {
      setParties(fullList);
    }
  }, [searchText]);
  return (
    <div
      style={{
        width: columns.reduce((acc, row) => acc + Number(row.width), 0) + 5,
        flex: 1,
      }}
      className="overflow-y-auto px-2 min-w-[320px] h-full "
    >
      <div
        style={{
          height: `calc(100% - 120px)`,
        }}
        className="mt-3 "
      >
        <GeniusTableReports
          rowID={(r) => r.ACCOUNT_NO}
          data={parties}
          columns={columns}
          dataGridHeader={true}
        />
      </div>
      <div className="flex justify-end mt-4">
        <Pagination
          page={currentPage}
          sx={{
            "& .MuiPaginationItem-root": {
              color: "#000",
              backgroundColor: "#f3f4f6", // light gray
              borderRadius: "8px", // rounded rectangle
              margin: "0 4px",
              minWidth: "36px",
              height: "36px",
            },
        
            "& .MuiPaginationItem-root:hover": {
              backgroundColor: "#e5e7eb",
            },
        
            "& .Mui-selected": {
              backgroundColor: "#000 !important",
              color: "#fff !important",
            },
        
            "& .Mui-selected:hover": {
              backgroundColor: "#000",
            },
          }}
          count={totalPageNumber}
          onChange={(e, v) => {
            getAccountData(v);
          }}
        />
      </div>

      <div
        style={{
          width: "100%",
          border: "1px solid #D2D2D7",
        }}
        className="rounded-sm p-1 mt-3 flex items-center justify-between  pl-2"
      >
        {" "}
        <div className=" ">
          <input
            type="text"
            value={searchText}
            className="w-full"
            style={{
              outline: "none ",
            }}
            placeholder="Search"
            onChange={(e) => {
              setSearchText(e.target.value);
            }}
          />
        </div>
        <div className="text-sm pr-3 text-gray-500">
          Records : {parties.length}
        </div>
      </div>
    </div>
  );
};

export default PartyList;
